module.exports = __webpack_public_path__ + "img/category-etc.ec449353.png";